import React, { Fragment, useContext, useRef, useState } from 'react';
import AnimateBlock from '../../components/AnimateBlock/AnimateBlock';
import BlockHeader from '../../components/BlockHeader/BlockHeader';
import ButtonTabs from '../../components/ButtonTabs/ButtonTabs';
import FullscreenImage from '../../components/FullscreenImage/FullscreenImage';
import { getMediaImage } from '../../components/Media/Image/utils';
import Media from '../../components/Media/Media';
import { getHeight } from '../../components/VideoBlock/VideoBlock';
import { ThemeValueContext } from '../../context/theme/ThemeValueContext';
import { Col, GridColumnOrderClasses, Row } from '../../grid';
import { Content } from '../../sub-blocks';
import { block, getThemedValue } from '../../utils';
import './Tabs.css';
const b = block('tabs-block');
export const TabsBlock = ({ items, title, description, animated, tabsColSizes, centered, direction = 'media-content', }) => {
    var _a;
    const [activeTab, setActiveTab] = useState(items[0].tabName);
    const [play, setPlay] = useState(false);
    const { themeValue: theme } = useContext(ThemeValueContext);
    const tabs = items.map(({ tabName }) => ({ title: tabName, id: tabName }));
    const activeTabData = items.find(({ tabName }) => tabName === activeTab);
    const isReverse = direction === 'content-media';
    const ref = useRef(null);
    const mediaWidth = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
    const mediaHeight = mediaWidth && getHeight(mediaWidth);
    let imageProps;
    if (activeTabData) {
        const themedImage = getThemedValue(activeTabData.image, theme);
        imageProps = themedImage && getMediaImage(themedImage);
    }
    const showMedia = Boolean((activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.media) || imageProps);
    const showText = Boolean(activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.text);
    const textContent = activeTabData && showText && (React.createElement(Col, { sizes: { all: 12, md: showMedia ? 4 : 8 }, className: b('content', { centered: centered }) },
        React.createElement("div", { className: b('content-wrapper', {
                margin: Boolean(((activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.media) || imageProps) && !isReverse),
            }) },
            React.createElement(Content, { title: activeTabData.title, text: activeTabData.text, additionalInfo: activeTabData.additionalInfo, size: "s", links: [
                    ...(activeTabData.link ? [activeTabData.link] : []),
                    ...(activeTabData.links || []),
                ], buttons: activeTabData.buttons, colSizes: { all: 12 } }))));
    const mediaContent = showMedia && (React.createElement(Col, { sizes: { all: 12, md: 8 }, orders: {
            all: GridColumnOrderClasses.Last,
            md: GridColumnOrderClasses.First,
        }, className: b('col', { centered: centered }) },
        React.createElement("div", { ref: ref }, (activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.media) && (React.createElement(Media, Object.assign({}, getThemedValue(activeTabData.media, theme), { key: activeTab, className: b('media'), playVideo: play, height: mediaHeight })))),
        imageProps && (React.createElement(Fragment, null,
            React.createElement(FullscreenImage, Object.assign({}, imageProps, { imageClassName: b('image') })))),
        (activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.caption) && React.createElement("p", { className: b('caption') }, activeTabData.caption)));
    const onSelectTab = (id, e) => {
        setActiveTab(id);
        e.currentTarget.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
    };
    return (React.createElement(AnimateBlock, { className: b(), onScroll: () => setPlay(true), animate: animated },
        React.createElement(BlockHeader, { title: title, description: description, className: b('block-title', { centered: centered }) }),
        React.createElement(Row, null,
            React.createElement(Col, { sizes: tabsColSizes },
                React.createElement(ButtonTabs, { items: tabs, onSelectTab: onSelectTab, activeTab: activeTab, className: b('tabs', { centered: centered }) }))),
        activeTabData && (React.createElement(Row, { className: b('row', { reverse: isReverse }) },
            mediaContent,
            textContent))));
};
export default TabsBlock;
